/* TUDD CRO – behaviour for custom conversion sections, blocks and snippets. No dependencies. */
(() => {
  if (window.__tuddCro) return;
  window.__tuddCro = true;

  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const addDays = (n) => {
    const d = new Date();
    d.setDate(d.getDate() + n);
    return d;
  };
  const fmt = (d) => `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTHS[d.getMonth()]}`;

  /* ---------------- Delivery estimate + pincode ---------------- */
  function initDelivery(root = document) {
    root.querySelectorAll('[data-tudd-delivery]:not([data-tudd-ready])').forEach((el) => {
      el.dataset.tuddReady = 'true';
      const min = parseInt(el.dataset.minDays, 10) || 5;
      const max = parseInt(el.dataset.maxDays, 10) || 7;
      const range = `${fmt(addDays(min))} – ${fmt(addDays(max))}`;
      const eta = el.querySelector('[data-tudd-eta]');
      if (eta) eta.textContent = range;

      const form = el.querySelector('[data-tudd-pin-form]');
      const input = el.querySelector('[data-tudd-pin]');
      const out = el.querySelector('[data-tudd-pin-result]');
      if (!form || !input || !out) return;

      const prefixes = (el.dataset.samedayPrefixes || '')
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean);

      let saved = '';
      try {
        saved = localStorage.getItem('tudd-pin') || '';
      } catch (e) {}
      if (saved) input.value = saved;

      const check = () => {
        const pin = input.value.replace(/\D/g, '');
        out.classList.remove('is-error');
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          out.textContent = 'Please enter a valid 6-digit pincode.';
          out.classList.add('is-error');
          return;
        }
        try {
          localStorage.setItem('tudd-pin', pin);
        } catch (e) {}
        const standard = (el.dataset.standardText || 'Delivery to {pin} by {date}')
          .replace('{pin}', pin)
          .replace('{date}', fmt(addDays(max)));
        const sameDay = prefixes.some((p) => pin.startsWith(p));
        out.textContent = sameDay ? `${el.dataset.samedayText} · or ${standard.charAt(0).toLowerCase()}${standard.slice(1)}` : standard;
      };

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        check();
      });
      input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
      });
      if (saved) check();
    });
  }

  /* ---------------- Add to cart helpers ---------------- */
  async function addItems(items) {
    const res = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    const cart = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`).then((r) => r.json());
    // Horizon listens for 'cart:update' to refresh the cart drawer, cart page and cart bubble,
    // and auto-opens the drawer when the event comes from an add.
    document.dispatchEvent(
      Object.assign(new Event('cart:update', { bubbles: true }), {
        detail: { resource: cart, sourceId: 'tudd-cro', data: { source: 'tudd-cro', itemCount: cart.item_count } },
      })
    );
    return cart;
  }

  function flash(btn, text) {
    const original = btn.dataset.label || btn.textContent;
    btn.dataset.label = original;
    btn.textContent = text;
    setTimeout(() => {
      btn.textContent = original;
    }, 1800);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-tudd-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      await addItems([{ id: Number(btn.dataset.tuddAdd), quantity: 1 }]);
      flash(btn, 'Added ✓');
    } catch (err) {
      flash(btn, 'Try again');
      console.error('[TUDD]', err);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------------- Bundle ---------------- */
  function formatMoney(cents, format) {
    const amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    if (!format) return `₹${amount}`;
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function initBundles(root = document) {
    root.querySelectorAll('[data-tudd-bundle]:not([data-tudd-ready])').forEach((el) => {
      el.dataset.tuddReady = 'true';
      const inputs = () => [...el.querySelectorAll('[data-tudd-bundle-variant]')];
      const priceOf = (input) => {
        const opt = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        return parseInt(opt.dataset.price, 10) || 0;
      };

      const update = () => {
        const fmtStr = el.dataset.moneyFormat;
        let total = 0;
        inputs().forEach((input) => {
          const p = priceOf(input);
          total += p;
          const priceEl = input.closest('.tudd-bundle__item')?.querySelector('[data-tudd-bundle-price]');
          if (priceEl) priceEl.textContent = formatMoney(p, fmtStr);
        });
        let pct = 0;
        let showNote = false;
        if (el.dataset.mode === 'fixed') {
          pct = parseInt(el.dataset.fixedPct, 10) || 0;
        } else if (total >= (parseInt(el.dataset.threshold, 10) || Infinity)) {
          pct = parseInt(el.dataset.offerPct, 10) || 0;
          showNote = pct > 0;
        }
        const now = Math.round((total * (100 - pct)) / 100);
        const was = el.querySelector('[data-tudd-bundle-was]');
        const badge = el.querySelector('[data-tudd-bundle-badge]');
        const note = el.querySelector('[data-tudd-bundle-note]');
        el.querySelector('[data-tudd-bundle-now]').textContent = formatMoney(now, fmtStr);
        if (was) {
          was.textContent = formatMoney(total, fmtStr);
          was.hidden = pct === 0;
        }
        if (badge) {
          badge.textContent = `Save ${pct}%`;
          badge.hidden = pct === 0;
        }
        if (note) note.hidden = !showNote;
      };

      el.addEventListener('change', (e) => {
        if (e.target.matches('[data-tudd-bundle-variant]')) update();
      });
      update();

      const cta = el.querySelector('[data-tudd-bundle-add]');
      cta?.addEventListener('click', async () => {
        cta.classList.add('is-loading');
        try {
          await addItems(inputs().map((i) => ({ id: Number(i.value), quantity: 1 })));
          flash(cta, 'Kit added ✓');
        } catch (err) {
          flash(cta, 'Try again');
          console.error('[TUDD]', err);
        } finally {
          cta.classList.remove('is-loading');
        }
      });
    });
  }

  /* ---------------- Watch & Shop: tap to play ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tudd-yt]');
    if (!btn || btn.classList.contains('is-playing')) return;
    const id = btn.dataset.tuddYt;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0&modestbranding=1&loop=1&playlist=${id}`;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = 'Tudd video';
    btn.appendChild(iframe);
    btn.classList.add('is-playing');
  });

  /* ---------------- Exit-intent popup ---------------- */
  function initExit() {
    const el = document.querySelector('[data-tudd-exit]');
    if (!el || el.dataset.tuddReady) return;
    el.dataset.tuddReady = 'true';

    const KEY = 'tudd-exit-seen';
    const days = parseInt(el.dataset.days, 10) || 7;
    const posted = el.dataset.posted === 'true';
    const hasErrors = el.dataset.hasErrors === 'true';
    let shown = false;

    const recentlySeen = () => {
      try {
        const t = parseInt(localStorage.getItem(KEY), 10);
        return t && Date.now() - t < days * 864e5;
      } catch (e) {
        return false;
      }
    };
    const open = () => {
      if (shown) return;
      shown = true;
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      try {
        localStorage.setItem(KEY, String(Date.now()));
      } catch (e) {}
      el.querySelector('input[type="email"], .tudd-exit__copy, .tudd-exit__cta')?.focus({ preventScroll: true });
    };
    const close = () => {
      el.hidden = true;
      document.documentElement.style.overflow = '';
    };

    el.addEventListener('click', (e) => {
      if (e.target.closest('[data-tudd-exit-close]')) close();
      const copy = e.target.closest('[data-tudd-copy]');
      if (copy) {
        navigator.clipboard?.writeText(copy.dataset.tuddCopy).then(() => (copy.textContent = 'Copied!'));
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !el.hidden) close();
    });

    // After the email form posts back, reopen to reveal the code (or show the error).
    if (posted || hasErrors) {
      shown = false;
      open();
      return;
    }
    if (el.dataset.designMode === 'true') return; // don't pop up while editing; preview via the URL below
    if (new URLSearchParams(location.search).has('tudd_popup')) return open();
    if (recentlySeen()) return;

    // Desktop: cursor leaves through the top of the window.
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth >= 750) open();
    });

    // Mobile: after a delay on site, or a fast scroll back up after reading.
    if (window.matchMedia('(max-width: 749px)').matches) {
      const delay = (parseInt(el.dataset.delay, 10) || 30) * 1000;
      setTimeout(open, delay);
      let lastY = window.scrollY;
      let lastT = Date.now();
      window.addEventListener(
        'scroll',
        () => {
          const y = window.scrollY;
          const t = Date.now();
          const speed = (lastY - y) / Math.max(t - lastT, 1); // px per ms, upward
          if (y > 600 && speed > 2.5) open();
          lastY = y;
          lastT = t;
        },
        { passive: true }
      );
    }
  }

  /* ---------------- Cart upsell: personalised + random per shopper ---------------- */
  const recCache = new Map(); // productId -> Promise<array of recommended products>
  const shuffle = (arr) => {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  const rootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function fetchRelated(productId) {
    if (!recCache.has(productId)) {
      recCache.set(
        productId,
        fetch(`${rootUrl()}recommendations/products.json?product_id=${productId}&limit=8&intent=related`)
          .then((r) => (r.ok ? r.json() : { products: [] }))
          .then((d) =>
            (d.products || [])
              .filter((p) => p.available)
              .map((p) => {
                const v = (p.variants || []).find((x) => x.available) || p.variants[0];
                const img = p.featured_image || (p.images && p.images[0]) || '';
                return {
                  id: p.id,
                  title: p.title,
                  url: p.url,
                  price: v ? v.price : p.price,
                  variant: v ? v.id : null,
                  image: img ? `${img}${img.includes('?') ? '&' : '?'}width=160` : '',
                };
              })
              .filter((p) => p.variant)
          )
          .catch(() => [])
      );
    }
    return recCache.get(productId);
  }

  async function pickUpsell(el) {
    const cartIds = (el.dataset.cartIds || '').split(',').filter(Boolean).map(Number);
    const max = parseInt(el.dataset.max, 10) || 3;
    const key = `tudd-upsell:${cartIds.slice().sort().join(',')}`;

    // Same cart -> same picks for this shopper (no jumping around on re-render)
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (Array.isArray(saved) && saved.length) return saved;
    } catch (e) {}

    let pool = [];
    try {
      pool = JSON.parse(el.querySelector('[data-tudd-upsell-pool]')?.textContent || '[]');
    } catch (e) {}

    const inCart = new Set(cartIds);
    const related = (await Promise.all(cartIds.map(fetchRelated))).flat();
    const seen = new Set();
    const uniq = (list) => list.filter((p) => !inCart.has(p.id) && !seen.has(p.id) && seen.add(p.id));

    // Related to what's in the cart first (shuffled), then random catalogue picks to fill
    const picks = [...shuffle(uniq(related)), ...shuffle(uniq(pool))].slice(0, max);
    try {
      sessionStorage.setItem(key, JSON.stringify(picks));
    } catch (e) {}
    return picks;
  }

  const esc = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  async function renderUpsell(el) {
    const sig = el.dataset.cartIds || '';
    const list = el.querySelector('[data-tudd-upsell-list]');
    if (!list) return;
    if (el.dataset.renderedFor === sig && list.children.length) return;
    if (el.dataset.rendering === sig) return;
    el.dataset.rendering = sig;

    const picks = await pickUpsell(el);
    if ((el.dataset.cartIds || '') !== sig) return; // cart changed meanwhile; a newer render will run
    const fmt = el.dataset.moneyFormat;
    list.innerHTML = picks
      .map(
        (p) => `<li class="tudd-upsell__item">
          <a href="${esc(p.url)}" class="tudd-upsell__img">${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" width="64" height="64" loading="lazy">` : ''}</a>
          <div class="tudd-upsell__info">
            <a href="${esc(p.url)}" class="tudd-upsell__title">${esc(p.title)}</a>
            <span class="tudd-upsell__price">${formatMoney(p.price, fmt)}</span>
          </div>
          <button type="button" class="tudd-upsell__add" data-tudd-add="${p.variant}" aria-label="Add ${esc(p.title)} to cart">+ Add</button>
        </li>`
      )
      .join('');
    el.hidden = picks.length === 0;
    el.dataset.renderedFor = sig;
    delete el.dataset.rendering;
  }

  let upsellQueued = false;
  function initUpsells() {
    if (upsellQueued) return;
    upsellQueued = true;
    setTimeout(() => {
      upsellQueued = false;
      document.querySelectorAll('[data-tudd-upsell]').forEach((el) => {
        const list = el.querySelector('[data-tudd-upsell-list]');
        // The theme re-renders the cart from server HTML (empty list), so refill when needed
        if (el.dataset.renderedFor !== el.dataset.cartIds || !list || !list.children.length) {
          delete el.dataset.renderedFor;
          renderUpsell(el);
        }
      });
    }, 30);
  }

  const init = (root) => {
    initDelivery(root);
    initBundles(root);
    initExit();
    initUpsells();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Re-run when Horizon re-renders sections (variant change, cart updates, theme editor).
  new MutationObserver((mutations) => {
    if (document.querySelector('[data-tudd-upsell]')) initUpsells();
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.matches?.('[data-tudd-delivery],[data-tudd-bundle]') || n.querySelector?.('[data-tudd-delivery],[data-tudd-bundle]'))) {
          init(document);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
